import { BASE_URL } from './config';

export const stampDocument = async (body, token) => {
  try {
    const res = await fetch(`${BASE_URL}signings/sign`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    const data = await res.json();

    if (res.ok) {
      return { success: true, httpStatus: res.status, ...data };
    }

    return {
      success: false,
      httpStatus: res.status,
      error: data.message || data.error || `HTTP error! status: ${res.status}`,
      ...data,
    };
  } catch (error) {
    console.error('Stamp document API Error:', error);
    return {
      success: false,
      error: error.message || 'Network error',
    };
  }
};
